export default "__VITE_ASSET__abb1785d__"